import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataLayerService {

  pushEvent(event) {
    const evntObj = {
      "event": event?.name,
      "eventGA4_name": event?.name,
      "event_category_ep": event?.category,
      "event_detail_ep": event?.detail,
      "event_label_ep": event?.label
    }
     window['dataLayer']?.push(evntObj);
  }

  pushManagePolicyEvent(label: string) {
     const event = {
        name: 'click_link',
        category: 'remarked content',
        detail: 'manage policy',
        label: label
      }

      this.pushEvent(event);
  }
}
